import { doc } from "firebase/firestore";
import { useRouter } from "next/router";
import React, { useEffect, useRef, useState } from "react";
import { useDocumentData } from "react-firebase-hooks/firestore";
import Loader from "../../../components/misc/Loader";
import { PackPage } from "../../../components/pack/PackPage";
import { db } from "../../../firebase";
import {
  getPackIdByPublicLink,
  getUser,
  getUserIdByNickname,
  packConverter,
  PackNotSharedErr,
  recordPackView,
  savePublicSharedPack,
} from "../../../firebase/firestore";
import useAuth from "../../../hooks/useAuth";

export default function PublicPackPage() {
  const router = useRouter();
  const { user } = useAuth();
  // @ts-ignore
  const { publicLink, nickname }: { publicLink: string; nickname: string } = router.query;
  const [creator, setCreator] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const cleanNickname: string = nickname.slice(1);
  const [packRef, setPackRef] = useState(null);
  useEffect(() => {
    (async () => {
      if (!user) return;
      setLoading(true);
      let creatorId = await getUserIdByNickname(cleanNickname);

      setCreator(await getUser(creatorId));
      try {
        let packId = await getPackIdByPublicLink(creatorId, publicLink);
        let packRef = doc(db, `users/${creatorId}/packs/${packId}`);

        // store the pack in the user's "shared with me"
        if (user.uid !== creatorId) savePublicSharedPack(user.uid, packRef, publicLink);
        setPackRef(packRef);
      } catch (e) {
        setError(e);
      }
      setLoading(false);
    })();
  }, [user, publicLink, nickname]);

  const [packData, packLoading, packError, packSnapshot] = useDocumentData(packRef?.withConverter(packConverter), {});

  const recordedView = useRef(false);

  useEffect(() => {
    if (
      user &&
      packData &&
      !recordedView.current &&
      creator &&
      creator.id !== user.uid &&
      // don't count views from collective members
      !(creator?.isCollective && creator.members.includes(user.uid))
    ) {
      recordPackView(packRef, user);
    }
  }, [packData, creator, user]);

  return (
    <div>
      {error ? (
        error == PackNotSharedErr ? (
          <div>{error.toString()}</div>
        ) : (
          <div>{error.toString()}</div>
        )
      ) : loading ? (
        <Loader />
      ) : (
        <PackPage
          creator={creator}
          canEdit={cleanNickname === user?.nickname}
          pack={packData && { ...packData, creator }}
          packRef={packRef}
          setPackRef={setPackRef}
        />
      )}
    </div>
  );
}
